import Toast from "./toast/main";
import Loading from "./loading/index";
import Dialog from "./dialog/index";
import Modal from "./modal/index";

const install = function(Vue) {
  Vue.$toast = Toast;
  Vue.$showLoading = Loading.show;
  Vue.$hideLoading = Loading.hide;
  Vue.$showDialog = Dialog.show;
  Vue.$hideDialog = Dialog.hide;

  Vue.prototype.$toast = Toast;
  Vue.prototype.$showLoading = Loading.show;
  Vue.prototype.$hideLoading = Loading.hide;
  Vue.prototype.$showDialog = Dialog.show;
  Vue.prototype.$hideDialog = Dialog.hide;

  Vue.prototype.$showModal = Vue.$showModal = Modal.show;
  Vue.prototype.$hideModal = Vue.$hideModal = Modal.hide;
};

export default install;
